// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorPage_errorContainer__3vz-g","errorCenter":"ErrorPage_errorCenter__3l4Nj","errorActions":"ErrorPage_errorActions__1khqt"};